import { useTranslation } from 'react-i18next';
import { QueryErrorState } from '../components/dashboard/QueryErrorState';
import { QueryLoadingBlock } from '../components/dashboard/QueryLoadingBlock';
import { formatFirstName } from '../lib/people/personName';
import { useMyProfile } from '../lib/profile/useMyProfile';
import { HomeHero } from './home/HomeHero';
import { HomeMobile } from './home/HomeMobile';
import { HomePlaylistsSection } from './home/HomePlaylistsSection';
import { HomeQuickActions } from './home/HomeQuickActions';
import { HomeSideRails } from './home/HomeSideRails';
import { useHomeData } from './home/useHomeData';

export function HomePage() {
  const { t } = useTranslation('home');
  const profileQuery = useMyProfile();
  const firstName = formatFirstName(profileQuery.data);
  const { model, isPending, isError, isRetrying, retry } = useHomeData();

  if (isError || isRetrying) {
    return (
      <QueryErrorState
        message={t('loadError')}
        onRetry={retry}
        isRetrying={isRetrying}
      />
    );
  }

  if (isPending || profileQuery.isPending) {
    return (
      <div className="flex flex-col gap-[22px]" aria-busy="true">
        <QueryLoadingBlock />
        <QueryLoadingBlock variant="cards" />
        <QueryLoadingBlock variant="rows" />
      </div>
    );
  }

  return (
    <>
      <HomeMobile
        onlineCount={model.onlineCount}
        rows={model.displayRows}
        canManage={model.canManage}
      />

      <div className="hidden flex-col gap-[22px] lg:flex" style={{ animation: 'gs-in 260ms ease both' }}>
        <HomeHero firstName={firstName} hero={model.hero} />
        <HomeQuickActions actions={model.quickActions} />
        <div className="flex flex-wrap items-start gap-6">
          <HomePlaylistsSection
            cards={model.cards}
            playingCount={model.playingCount}
            canManage={model.canManage}
          />
          <HomeSideRails
            recent={model.recent}
            issues={model.issues}
            hasScreens={model.hasScreens}
            canManage={model.canManage}
          />
        </div>
      </div>
    </>
  );
}
